import React from 'react';
import LayerRecommendation from './weather/LayerRecommendation';
import TemperatureDisplay from './weather/TemperatureDisplay';
import WeatherAlerts from './weather/WeatherAlerts';
import TemperatureUnitToggle from './TemperatureUnitToggle';
import JsonLd, { todayJsonLd } from './JsonLd';
import LlmAnswer, { todayAnswerText } from './LlmAnswer';

const WeatherDisplay = ({ data, location, coordinates, forecastHours, alertForecastHours, onRecommendationShown }) => {

  const displayLocation = location 
    ? location.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') 
    : (coordinates ? 'Your location' : 'Unknown location');

  // Call increment when recommendation is shown (only once per recommendation)
  React.useEffect(() => {
    if (data?.recommendation && onRecommendationShown) {
      onRecommendationShown(data.recommendation);
    }
  }, [data?.recommendation, onRecommendationShown]);

  const jsonLd = todayJsonLd({
    city: displayLocation,
    latitude: coordinates?.latitude,
    longitude: coordinates?.longitude,
    recommendation: data.recommendation,
    displayTemp: data.temperature?.display,
    forecastHours
  });
  const llmText = todayAnswerText({
    city: displayLocation,
    displayTemp: data.temperature?.display,
    recommendation: data.recommendation,
    forecastHours
  });

  return (
    <div className="result-card space-y-3 relative">
      <JsonLd data={jsonLd} />
      <LlmAnswer>{llmText}</LlmAnswer>
      {data.recommendation && (
        <LayerRecommendation
          recommendation={data.recommendation}
          location={location}
          forecastHours={forecastHours}
        />
      )}

      {/* Glass card so the city + temperature read clearly against the gradient. */}
      <div className="rounded-xl border border-foreground/10 bg-background/30 backdrop-blur-md p-3 space-y-3">
        <h3 className="text-xl font-light text-gray-900 dark:text-gray-100">
          Weather in {displayLocation}
        </h3>

        <div className="flex items-start justify-between gap-3">
          <TemperatureDisplay
            temperature={data.temperature.display}
            forecastHours={forecastHours}
            minTemp={data.temperature.dailyLow}
            maxTemp={data.temperature.dailyHigh}
          />
          <TemperatureUnitToggle />
        </div>

        <WeatherAlerts
          isRainExpected={data.conditions.precipitation > 0}
          isSnowExpected={data.conditions.precipitation > 0 && data.temperature.actual < 0}
          forecastHours={forecastHours}
          alertForecastHours={alertForecastHours}
          windSpeed={data.conditions.windSpeed}
        />
      </div>
    </div>
  );
};

export default WeatherDisplay;